/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React from 'react'
import RsCarousel, { RsCarouselState } from './rs-carousel';
import { connect } from 'react-redux';
import { isUserManager } from '../../selectors/user';
import { RatingModal } from '@features/initiative/ratings/RatingModal';
import EditButton from '@g17eco/molecules/button/EditButton';
import { RootState } from '../../reducers';
import { RatingAgencyRating } from '../../types/initiative';
import IconButton from '@g17eco/molecules/button/IconButton';
import { BasicAlert } from '@g17eco/molecules/alert';
import { SimpleTooltip } from '@g17eco/molecules/simple-tooltip';
import G17Client from '../../services/G17Client';

interface RatingsCarouselState extends RsCarouselState {
  ratingModal: {
    isOpen: boolean;
    itemId?: string;
    itemCode: string;
  }
}

class RatingsCarousel extends RsCarousel {
  _isMounted = false;
  state: RatingsCarouselState = {
    headingText: 'Ratings and Certifications',
    linkTooltip: 'For further information please contact Rating Provider',
    ratingModal: {
      isOpen: false,
      itemCode: '',
    }
  };

  componentDidMount() {
    this._isMounted = true;
    this.reload();
  }

  reload = async () => {
    try {
      const results = await G17Client.getRatings(this.props.initiativeId);

      if (this._isMounted) {
        this.setState({
          loaded: true,
          items: Array.isArray(results) ? results : []
        });
      }
    } catch (e) {
      if (this._isMounted) {
        this.setState({ errorMessage: e.message, hasError: true });
      }
      console.error(e);
    } finally {
      if (this._isMounted) {
        this.setState({ loaded: true });
      }
    }
  }

  renderInfoButton(item: RatingAgencyRating) {
    return <SimpleTooltip text={item.additionalInformation}>
      <IconButton outline icon='fa-info-circle' />
    </SimpleTooltip>
  }

  renderNoItems() {
    if (!this.canEdit() && !this.props.showNoItems) {
      return super.renderNoItems();
    }

    return this.renderWithWrapper(
      <BasicAlert type='primary'>No ratings available</BasicAlert>
    );
  }

  renderItemEditButton(item: RatingAgencyRating) {
    const { readOnly, isManager } = this.props;
    const canEdit = !readOnly && isManager;
    if (!canEdit) {
      return <></>;
    }

    return <IconButton outline onClick={() => this.displayEditItemModal(item.code, item._id)} icon='fal fa-cog' />
  }

  renderEditButton() {
    return <EditButton onClick={() => this.setState({
      ratingModal: {
        ...this.state.ratingModal,
        isOpen: true,
        itemId: undefined,
        itemCode: '',
      }
    })} />
  }

  renderFooter(items: RatingAgencyRating[]) {
    const { ratingModal } = this.state;
    const { isOpen, itemCode, itemId } = ratingModal;

    if (ratingModal.isOpen !== true) {
      return <></>;
    }

    return <RatingModal
      toggle={() => this.setState({
        ratingModal: {
          ...ratingModal,
          isOpen: !isOpen
        }
      })}
      isOpen={ratingModal.isOpen}
      itemCode={itemCode}
      itemId={itemId}
      initiativeId={this.props.initiativeId}
      onSubmit={() => this.reload()}
      ratings={items}
    />
  }


  displayEditItemModal(code: string, id?: string) {
    return this.setState({
      ratingModal: {
        ...this.state.ratingModal,
        isOpen: true,
        itemCode: code,
        itemId: id,
      }
    });
  }
}

const mapStateToProps = (state: RootState) => ({
  isManager: isUserManager(state),
});

export default connect(mapStateToProps)(RatingsCarousel);
